import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    setMenuOpen(false);
    navigate(kw ? `/search?q=${encodeURIComponent(kw)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer shrink-0">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-film-line text-xl" />
            </span>
            <span className="flex flex-col leading-tight">
              <span className="text-base md:text-lg font-bold text-foreground-950 whitespace-nowrap">
                肮脏的交易
              </span>
              <span className="hidden sm:block text-xs text-foreground-500 whitespace-nowrap">
                影视资讯与剧情解析
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <form
              onSubmit={handleSearch}
              className="hidden lg:flex items-center rounded-md border border-background-300 bg-background-100 pl-3 pr-1 focus-within:border-primary-400 transition-colors"
            >
              <i className="ri-search-line text-base text-foreground-400" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视标题、类型、演员"
                className="w-52 bg-transparent px-2 py-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 xl:w-64"
              />
              <button
                type="submit"
                className="rounded-md bg-primary-600 px-3 py-1.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-700 cursor-pointer"
              >
                搜索
              </button>
            </form>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开菜单"
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-700 md:hidden cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <form
            onSubmit={handleSearch}
            className="mb-3 flex items-center rounded-md border border-background-300 bg-background-100 pl-3 pr-1"
          >
            <i className="ri-search-line text-base text-foreground-400" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视标题、类型、演员"
              className="flex-1 bg-transparent px-2 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="rounded-md bg-primary-600 px-3 py-2 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}